import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/13-2_close.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const Close: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default Close;
